const detectIncognitoMode = async (): Promise<boolean> => {
    return new Promise(resolve => {
        // Chrome/Edge/Opera (Storage quota)
        if (navigator.storage && navigator.storage.estimate) {
            navigator.storage.estimate().then(estimate => {
                if (estimate.quota && estimate.quota < 120 * 1024 * 1024) {
                    resolve(true);
                } else {
                    resolve(false);
                }
            }).catch(() => resolve(false));
            return;
        }

        const fs = (window as any).RequestFileSystem || (window as any).webkitRequestFileSystem;
        if (!fs) {
            resolve(false); // Not supported; cannot detect
            return;
        }

        fs(
            (window as any).TEMPORARY,
            100,
            () => resolve(false), // Normal mode
            () => resolve(true) // Incognito mode
        );
    });
};

export default detectIncognitoMode;
